import axios from 'axios';
import { getAccWebApiDomain, getBaseApiDomain } from './utils';
import qs from 'qs';

axios.defaults.withCredentials = true;

/**
 * 获取登录状态
 * @param data
 * @returns
 */
export function getAccountStatus(data) {
	const baseUrl = getAccWebApiDomain();
	return axios.post(`${baseUrl}/passport/login/check`, data);
}

/**
 * 获取兑换码
 * @param data
 * @returns
 */
export function getRedeemCode(data) {
	const baseUrl = getBaseApiDomain();
	return axios.post(`${baseUrl}/coupon/redemptionCode/sdkWriteOff`, qs.stringify(data));
}
